<template>
  <div>
    <mu-toast v-if="toast" :message="toastmessage" @close="hideToast"/>
    <mu-drawer :open="open" :docked="docked" @close="toggle()">
      <mu-list @itemClick="docked ? '' : toggle()">
        <mu-menu-item title="使用說明" @click="openAction"/>
        <mu-menu-item title="FB登入" @click="fbSignIn" v-if="!currentUser"  />
        <mu-menu-item title="Google登入" @click="signIn" v-if="!currentUser"  />
        <mu-menu-item title="登出" @click="signOut" v-if="currentUser"  />
        <mu-menu-item title="" />
        <mu-menu-item title="正常版" @click="loadProduct(0)"/>
        <mu-menu-item title="歡樂測試版" @click="loadProduct(2)"/>
        <mu-menu-item title="" href="/#/chatPage" />
      </mu-list>
    </mu-drawer>
    <mu-appbar>
      <mu-icon-button icon='menu' slot="left" @click="toggle(true)"/>
      <mu-sub-header><h1>地圖佈告欄</h1></mu-sub-header>
      <mu-flat-button color="white" label="Login" slot="right" @click="fbSignIn" v-if="!currentUser" />
      <mu-flat-button color="white" :label="currentUser.displayName" slot="right" @click="" v-if="currentUser" />
    </mu-appbar>
    <div id="map"></div>
    <div id="sidebar">
          <div v-if="currentUser && wantSell">
            <h1>在這裡寫下你想做的事吧</h1>
            <mu-content-block>
              <div class="demo-grid">
            <mu-raised-button class="demo-raised-button" label="上傳圖片">
              <input accept="image/*,capture=camera" @change="saveImageMessage" type="file" class="file-button">
            </mu-raised-button><br />
            <mu-circular-progress v-if="isUpload" :size="40"/><br />
            <mu-card-media v-if="productPhoto">
            	<img class="product-photo" :src="productPhoto" />
        	</mu-card-media>
            <mu-text-field label="標題(物品，服務等)" type="text" :errorText="(!title) ? '不可空白' : ''" labelFloat v-model="title" /><br/>
            <mu-text-field label="費用" type="number" labelFloat v-model="price" /><br/>
            <mu-text-field hintText="敘述你的物品或服務內容吧，如：尺寸，顏色" multiLine :rows="4" v-model="description"/><br/>
            <mu-text-field label="概略地點 (optional)" type="text" hintText="如：台北市大安區" labelFloat v-model="address"/><br/>
            <mu-text-field label="關鍵字 (optional)" type="text" hintText="逗點分隔關鍵字，如：nike,puma..." labelFloat v-model="keywords" /><br/>
            <mu-raised-button label="送出" class="demo-raised-button" @enter="addProduct(0)" @click="addProduct(0)" primary/>
            <mu-raised-button label="歡樂測試版" class="demo-raised-button" @click="addProduct(2)" primary/>
              </div>
            </mu-content-block>
            <mu-content-block>
            	<h3>預覽：</h3>
	            <mu-card>
	              <mu-card-media >
	                <img class="product-photo" :src="productPhoto" />
	              </mu-card-media>
	              <mu-card-title :title="title" :subTitle="(price) ? ' NT$' + price : ''"/>
	              <mu-card-text class="text-align-left">
	                <pre>{{description}}</pre>
	                {{ (address) ? '地點：' + address : '' }}
	              </mu-card-text>
	              <mu-card-text class="text-align-left" v-if="keywords.length > 0">
	                <div v-for="keyword in keywords.split(',') ">
	                  <span><a :href="'#'+keyword">#{{keyword}}</a></span>
	                </div>
	              </mu-card-text>
	              <mu-card-header title="剛剛建立" :subTitle="'來自 ' + currentUser.displayName">
	                <mu-avatar :src="currentUser.photoURL" slot="avatar"/>
	              </mu-card-header>
	              <mu-sub-header style="color: #f1efef;">({{point.lat}} {{point.lng}})</mu-sub-header>
	            </mu-card>
            </mu-content-block>
          </div>
          <div v-else-if="products[geokey]">
            <h1>這裡有塊板子上面寫著：</h1>
            <mu-card>
              <mu-card-media >
                <img class="product-photo" :src="products[geokey].productPhoto" />
              </mu-card-media>
              <mu-card-title :title="products[geokey].title" :subTitle="(products[geokey].price) ? ' NT$' + products[geokey].price : ''"/>
              <mu-card-text class="text-align-left">
                <pre>{{products[geokey].description}}</pre>
                {{ (products[geokey].address) ? '地點：' + products[geokey].address : '' }}
              </mu-card-text>
              <mu-card-text class="text-align-left" v-if="this.products[this.geokey].keywords.length > 0">
                <div v-for="keyword in splitArray">
                  <span><a :href="'#'+keyword">#{{keyword}}</a></span>
                </div>
              </mu-card-text>
              <mu-card-header :title="productCreateTime+ ' 前建立'" :subTitle="'來自 ' + products[geokey].userName">
                <mu-avatar :src="products[geokey].userPhotoUrl" slot="avatar"/>
              </mu-card-header>
              <mu-card-actions>
                <mu-raised-button v-if="!currentUser || currentUser.uid !== products[geokey].userUid" :label="'丟訊息問問 ' + products[geokey].userName" @click="gossimOpen(products[geokey].userUid, products[geokey].userName)" /><span v-if="!currentUser || currentUser.uid !== products[geokey].userUid" >(此人{{products[geokey].userLoginStatus ? '在線上' : '離線' }})</span>
              </mu-card-actions>
              <mu-card-actions v-if="currentUser && currentUser.uid === products[geokey].userUid">
                <mu-raised-button label="移動你的板子後，儲存位置。" @click="updateProductLocation(geokey)" /><br><br>
                <mu-raised-button label="刪除這塊留言板。" @click="deleteProduct(geokey)" secondary/>
              </mu-card-actions>
              <mu-sub-header style="color: white">位於 {{point.lat}} {{point.lng}}</mu-sub-header>
            </mu-card>
      </div>
    </mu-content-block>
    <mu-popup popupClass="demo-popup-bottom" :open="bottomPopup" @close="closeAction">
      <mu-appbar title="使用說明">
        <mu-flat-button slot="right" label="關閉" color="white" @click="closeAction"/>
      </mu-appbar>
      <mu-content-block>
        <h3>操作方式：</h3>
        <p>
          未登入時，可觀看附近的留言板。
          登入時，可任意在地圖上加入，移動，刪除留言板。
          可與對方私訊交談，即使對方不在線上也會寄信通知。
        </p>
        <h3>作者：</h3>
        <p>
          Created by <a href="https://www.facebook.com/yijuwu">Mark</a>.<br>
          連結<a href="https://www.facebook.com/yijuwu">https://www.facebook.com/yijuwu</a><br>
          有任何問題或改進方案都可以提供給我，謝謝！
        </p>
      </mu-content-block>
    </mu-popup>
    </div>
  </div>
</template>
<script>
import map from 'assets/js/map'
import Firebase from 'firebase'
import {auth, db, storage, geoFire} from './firebaseApp'
import myron from './assets/images/uicon.jpg'
import distanceInWordsToNow from 'date-fns/distance_in_words_to_now'
import {event} from './utils'
import router from './router'
import sidebar from 'assets/js/sidebar'
import Gossim from 'Gossim'
var productsRef = db.ref('products')
var initMap = null

export default {
  data () {
    return {
      bottomPopup: false,
      open: false,
      docked: true,
      isUpload: false,
      wantSell: false,
      geokey: '',
      products: {},
      title: '',
      price: '',
      address: '',
      description: '',
      keywords: '',
      currentUser: null,
      toast: false,
      point: {
        lat: '',
        lng: ''
      },
      productPhoto: '',
      myron
    }
  },
  computed: {
    splitArray () {
      return this.products[this.geokey].keywords.split(',')
    },
    productSplitArray () {
      return this.products.map((product) => {
        return (product.keywords) ? product.keywords.split(',') : []
      })
    },
    productCreateTime () {
      return (this.products[this.geokey].createTime) ? distanceInWordsToNow(this.products[this.geokey].createTime) : '不知何時'
    }
  },
  methods: {
    openAction (e) {
      this.bottomPopup = true
    },
    closeAction () {
      this.bottomPopup = false
    },
    toggle (flag) {
      this.open = !this.open
      this.docked = !flag
    },
    addProduct (state) {
      var currentUser = auth.currentUser
      if (currentUser && this.title) {
        var key = productsRef.push({
          productPhoto: this.productPhoto,
          title: this.title,
          price: this.price,
          address: this.address,
          description: this.description,
          keywords: this.keywords,
          userUid: currentUser.uid,
          userPhotoUrl: currentUser.photoURL,
          userName: currentUser.displayName,
          createTime: Firebase.database.ServerValue.TIMESTAMP,
          state: state
        }).key
        geoFire.set(key, [this.point.lat, this.point.lng]).then(() => {
          sidebar().hide()
        })
        this.productPhoto = ''
        this.title = ''
        this.price = ''
        this.address = ''
        this.description = ''
        this.keywords = ''

        router.replace({ path: 'mapPage',
          query: {
            state: state
          }
        })
      } else {
        this.showToast('至少也寫個標題吧？', 2000)
      }
    },
    updateProductLocation: function (key) {
      if (auth.currentUser) {
        geoFire.set(key, [this.point.lat, this.point.lng]).then(() => {
          sidebar().hide()
          window.alert('已更新這個地點的位置')
        })
      }
      // @input="updateMessageText(message, event.target.value)"
    },
    deleteProduct: function (key, state) {
      if (auth.currentUser && window.confirm('確定要刪除這個板子？')) {
        productsRef.child(key).child('state').set(3)
        sidebar().hide()
        window.alert('已移除這個地點')
      }
      // @input="updateMessageText(message, event.target.value)"
    },
    signIn () {
      var provider = new Firebase.auth.GoogleAuthProvider()
      auth.signInWithPopup(provider)
    },
    fbSignIn () {
      var provider = new Firebase.auth.FacebookAuthProvider()
      auth.signInWithPopup(provider)
    },
    signOut () {
      auth.signOut()
    },
    checkSignedInWithMessage () {
      // Return true if the user is signed in Firebase
      if (auth.currentUser) {
        return true
      }

      // Display a message to the user using a Toast.
      var data = {
        message: 'You must sign-in first',
        timeout: 2000
      }
      this.showToast(data)
      return false
    },
    saveImageMessage (event) {
      var file = event.target.files[0]

      // Check if the file is an image.
      if (!file.type.match('image.*')) {
        var data = {
          message: 'You can only share images',
          timeout: 2000
        }
        this.showToast(data)
        return
      }

      // Check if the user is signed-in
      if (this.checkSignedInWithMessage()) {
        this.isUpload = true
        // We add a message with a loading icon that will get updated with the shared image.
        var currentUser = auth.currentUser

        // Upload the image to Firebase Storage.
        storage.ref(currentUser.uid + '/' + Date.now() + '/' + file.name)
            .put(file, {contentType: file.type})
            .then((snapshot) => {
              // Get the file's Storage URI and update the chat message placeholder.
              var filePath = snapshot.metadata.fullPath
              return storage.ref(filePath).getDownloadURL()
            }).then((url) => {
              this.isUpload = false
              this.productPhoto = url
            }).catch((error) => {
              console.error('There was an error uploading a file to Firebase Storage:', error)
            })
      }
    },
    showToast (data) {
      this.toast = true
      this.toastmessage = data.message
      if (this.toastTimer) clearTimeout(this.toastTimer)
      this.toastTimer = setTimeout(() => { this.toast = false }, data.timeout)
    },
    hideToast () {
      this.toast = false
      if (this.toastTimer) clearTimeout(this.toastTimer)
    },
    showSidebar (key, latlng) {
      this.wantSell = false
      this.geokey = key
      this.point = latlng
      if (!sidebar().isVisible()) {
        sidebar().show()
        this.isUserOnline(this.products[this.geokey].userUid)
      }
    },
    loadProduct (state) {
      router.replace({ path: 'mapPage',
        query: {
          state: state
        }
      })
      this.initProduct(state)
    },
    initProduct (state) {
      initMap.resetMarkerClusterGroup()
      var setProduct = (data) => {
        var val = data.val()
        var key = data.key
        this.products[key] = val
        geoFire.get(key).then((location) => {
          if (location === null) {
            console.log('Provided key is not in GeoFire')
          } else {
            initMap.addPoint({key: key, title: val.title, location: location, pic: (val.productPhoto || val.userPhotoUrl), isMyPoint: (auth.currentUser && val.userUid === auth.currentUser.uid)})
          }
        })
      }
      productsRef.orderByChild('state').equalTo(state).limitToLast(100).on('child_added', setProduct)
    },
    gossimOpen (uid, name) {
      Gossim.popup(uid, name)
    },
    isUserOnline (id) {
      Gossim.isUserOnline(id, (returnId, isOnline) => {
        this.products[this.geokey].userLoginStatus = isOnline
      })
    }
  },
  beforeCreate () {
    event.init()
    event.on('setLocationNumfunction', (point) => {
      this.wantSell = true
      this.point = point
    })
    event.on('setProductLocation', (point) => {
      this.point = point
    })
    event.on('showPoint', (point) => {
      var key = point.target.options.location_key
      this.showSidebar(key, point.latlng)

      var query = {product_id: key}
      if (this.$route.query.state) {
        query.state = this.$route.query.state
      }

      router.replace({ path: 'mapPage',
        query: query
      })
    })
  },
  mounted () {
    initMap = map(window)
    initMap.locateSelf()
    auth.onAuthStateChanged((user) => {
      this.currentUser = user
      initMap.isLogin(user)
      if (user) {
        Gossim.setUserInfo({
          id: user.uid,
          name: user.displayName,
          image: user.photoURL,
          email: user.email
        })
      }

      var productId = this.$route.query.product_id
      if (productId) {
        productsRef.orderByKey().equalTo(productId).on('child_added', (data) => {
          var val = data.val()
          var key = data.key
          this.products[key] = val
          geoFire.get(key).then((location) => {
            this.showSidebar(key, {lat: location[0], lng: location[1]})
          })
        })
      }
      var state = this.$route.query.state
      if (state) {
        this.initProduct(parseInt(state))
      } else {
        this.loadProduct(0)
      }
    })
  }
}
</script>
<style lang="css">
body {
    padding: 0;
    margin: 0;
}
html, body {
    height: 100vh;
    width: 100vw;
}
#map {
    height: 92vh;
}
.mu-appbar{
    height: 4vh;
    width: 100vw;
}
.leaflet-zoom-animated {
  z-index: 1 !important;
}

.leaflet-google-layer {
  z-index: 0 !important;
}
.demo-grid div[class*="col-"] {
  background: #fff;
  color: #000;
  padding: 8px;
  margin-bottom: 8px;
  margin-left:auto;
  margin-right:auto;
}
.text-align-left {
  text-align: left;
  word-break: break-all;
}
.file-button{
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  opacity: 0;
}

.demo-raised-button {
  margin: 12px;
}
.product-photo {
  max-height: 400px;
}
.custom_icon {
  border-radius: 50%;
  box-shadow: 5px 5px 10px #888;
}
</style>


// WEBPACK FOOTER //
// MapPage.vue?0746071e